// Sizes calculating module

/**
 * Return rectangle parameters reduced to fit maximum width and height
 * @param {Number} width Origin rectangle with
 * @param {Number} height Origin rectangle height
 * @param {Number} maxWidth Maximum width
 * @param {Number} maxHeight Maximum height
 */
export const fitSizesToBorders = (width, height, maxWidth, maxHeight) => {
  if (width <= maxWidth && height <= maxHeight) {
    // Check that rectangle parameters already is in valid range
    return {
      width: width,
      height: height
    };
  }

  if (maxWidth / width > maxHeight / height) {
    // Set sizes by height, if rectangle more vertical than bounding rectangle
    return {
      width: (width / height) * maxHeight,
      height: maxHeight
    };
  }
  // Set sizes by width, if rectangle more horizontal than bounding rectangle
  return {
    width: maxWidth,
    height: (height / width) * maxWidth
  };
};
